"use strict";
var Backbone = require("backbone");
var _ = require("underscore");
var jwt_decode = require("jwt-decode");
var STR = require("../strings");

var debug = require("debug")("views:PrintPasswordView"); //https://github.com/visionmedia/debug
var template = require("../templates/print-password-template.html");


/**
 * PrintPasswordView: recherche et affiche le code que devra rentrer l'utilisateur pour décrypter le pdf
 */
module.exports = Backbone.View.extend({

    model: null, // PrintOptionsModel
    className: "rbn-print-password-view",
    template: _.template(template), // compile template

    events: {
        "click .rbn-next": "onNextClicked",
        "click .rbn-copy-code": "onCopyCodeClicked"
    },

    initialize: function (options) {
        var T = this;
        T.decodedPassword = null;
        _.extend(T, options);

        T.listenTo(T.model, "sync", T.render);
        T.model.fetch();
    },

    onNextClicked: function (e) {
        var T = this;
        e.stopPropagation();
        T.onNextCallback(T.decodedPassword,T.model.get("passwordToken"));
    },

    onCopyCodeClicked: function (e) {
        var T = this;
        e.stopPropagation();
        T.onCopyCodeCallback(T.decodedPassword);
    },

    render: function () {
        var T = this;
        debug("render");

        var context = {
            STR: STR,
            pwd: null
        };

        if (T.model.fetched) {
            var decoded = jwt_decode(T.model.get("passwordToken"));
            if (decoded.pwd) {
                T.decodedPassword = context.pwd = decoded.pwd;
            }
        }
        T.$el.html(T.template(context));
        return T;
    },

    close: function () {
        var T = this;
        T.stopListening();
        T.undelegateEvents();
    }

});


//////////////////
// WEBPACK FOOTER
// ./src/views/print-password-view.js
// module id = 59
// module chunks = 0